import { updateSettings } from '../subscriptions/ajax.js';
import { ROUTE_ACCOUNT_SOURCE_OF_WEALTH } from '~/components/router/constants.js';
import { updateCrossMarketingFlag } from '~/components/account';

export const allCategories = [
	'INBOX_CATEGORY_ALL',
	'INBOX_CATEGORY_PROMOTIONS',
	'INBOX_CATEGORY_ACCOUNT',
	'INBOX_CATEGORY_SPORTS',
	'INBOX_CATEGORY_CASINO',
	'INBOX_CATEGORY_GAME_RELEASES'
];

const handleCTAClick = ({ ctaUrlPresetType, ctaUrl, ctaUrlType }, router, basePathname) => {
	switch (Number.parseInt(ctaUrlPresetType, 10)) {
		// EXTERNAL URL - [Same tab]
		case 1:
			window.location.href = ctaUrl;
			break;

		// COMEON INTERNAL - [ComeOn mobileview defined routes]
		case 2:
		case 3:
		case 4:
		case 5:
		case 7:
		case 8:
		case 9:
		case 10:
			router.push(ctaUrl);
			break;

		case 13:
			router.push(ROUTE_ACCOUNT_SOURCE_OF_WEALTH);
			break;

		// COMEON EXTERNAL - [Not configuered in Route; so need a full reload of page]
		case 6:
			window.location.href = window.location.origin + ctaUrl;
			break;

		// EXTERNAL URL - [NEW tab]
		case 11:
			window.open(ctaUrl, '_blank');
			break;

		// Marketing Opt-in ALL [email, sms, phone, mail]
		case 12:
			updateSettings({ email: true, sms: true, phone: true, mail: true });
			// Close the account menu
			router.push(basePathname);
			break;
		// B2B marketing opt-in
		case 14:
			updateCrossMarketingFlag(true);
			router.push(basePathname);
			break;

		default:
			// Fallback for notifications [IF ANY] that has no preset ID
			if (ctaUrlType === `external`) {
				window.location.href = ctaUrl;
			} else if (ctaUrlType === `comeon-external`) {
				// ComeOn URL: [Not configuered in Route; so need a full reload of page]
				window.location.href = window.location.origin + ctaUrl;
			} else {
				// ComeOn configuered URL: [Can directly push history]
				router.push(ctaUrl);
			}
			break;
	}
};

export const isTextKey = text => {
	return /^[A-Z0-9_]+$/.test(text);
};

export default handleCTAClick;
